document.addEventListener("DOMContentLoaded", function () {
  // Utility: Check if an element is at least partially in the viewport.
  function isElementPartiallyInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  // Select container, logos (and its container), and quote wrapper elements
  const container = document.querySelector(".dev-customer-reviews__quotes");
  const logos = document.querySelectorAll(".dev-customer-reviews__logo");
  const logosContainer = document.querySelector(
    ".dev-customer-reviews__logos-container",
  );
  const quoteWrappers = document.querySelectorAll(
    ".dev-customer-reviews__quote-wrapper",
  );
  const sectionContainer = document.querySelector(".dev-customer-reviews");

  // Track the current active slide and prevent overlapping transitions
  let currentActiveIndex = 0;
  let isAnimating = false;
  let autoplayInterval = null;

  // Initially show the first quote wrapper and adjust container height accordingly.
  gsap.set(quoteWrappers[currentActiveIndex], { opacity: 1, y: "0%" });
  gsap.set(container, {
    height: quoteWrappers[currentActiveIndex].offsetHeight,
  });

  // Helper function to transition to a given slide index.
  function transitionToSlide(newIndex) {
    if (isAnimating || newIndex === currentActiveIndex) return;

    // Immediately update active logo classes.
    logos[currentActiveIndex].classList.remove(
      "dev-customer-reviews__logo-active",
    );
    logos[newIndex].classList.add("dev-customer-reviews__logo-active");

    // Immediately scroll the new logo into view only if the logos container is visible.
    if (isElementPartiallyInViewport(logosContainer)) {
      logos[newIndex].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }

    isAnimating = true;
    const oldQuoteWrapper = quoteWrappers[currentActiveIndex];
    const newQuoteWrapper = quoteWrappers[newIndex];
    const newHeight = newQuoteWrapper.offsetHeight;

    // Create the GSAP timeline to animate the quote transition.
    const tl = gsap.timeline({
      onComplete: function () {
        oldQuoteWrapper.classList.remove("dev-customer-reviews__quote-active");
        newQuoteWrapper.classList.add("dev-customer-reviews__quote-active");
        currentActiveIndex = newIndex;
        isAnimating = false;
      },
    });

    // Animate container height to match the new quote wrapper.
    tl.to(
      container,
      {
        duration: 0.5,
        height: newHeight,
        ease: "power1.out",
      },
      0,
    );

    // Animate the old quote wrapper out (upward and fading out).
    tl.to(
      oldQuoteWrapper,
      {
        duration: 0.5,
        y: "-100%",
        opacity: 0,
        ease: "power1.in",
      },
      0,
    );

    // Position the new quote wrapper below the visible area.
    tl.set(newQuoteWrapper, { y: "100%", opacity: 0 }, 0.5);

    // Animate the new quote wrapper in (upward and fading in).
    tl.to(
      newQuoteWrapper,
      {
        duration: 0.5,
        y: "0%",
        opacity: 1,
        ease: "power1.out",
      },
      0.5,
    );
  }

  // Function to restart the autoplay timer
  function restartAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
    }
    autoplayInterval = setInterval(function () {
      // Only animate if the section is visible in the viewport
      if (isElementPartiallyInViewport(sectionContainer)) {
        const nextIndex = (currentActiveIndex + 1) % logos.length;
        transitionToSlide(nextIndex);
      }
    }, window.settingsAnimationTime * 1000);
  }

  // Attach click events to the logos.
  logos.forEach((logo, index) => {
    logo.addEventListener("click", function () {
      transitionToSlide(index);
    });
  });

  // Attach click events to mobile navigation arrows.
  const prevArrow = document.querySelector(
    ".dev-customer-reviews__arrow--prev",
  );
  const nextArrow = document.querySelector(
    ".dev-customer-reviews__arrow--next",
  );

  if (prevArrow) {
    prevArrow.addEventListener("click", function () {
      const prevIndex = (currentActiveIndex - 1 + logos.length) % logos.length;
      transitionToSlide(prevIndex);
      restartAutoplay();
    });
  }

  if (nextArrow) {
    nextArrow.addEventListener("click", function () {
      const nextIndex = (currentActiveIndex + 1) % logos.length;
      transitionToSlide(nextIndex);
      restartAutoplay();
    });
  }

  // Start autoplay
  restartAutoplay();
});
